import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../SiteSettingsContext';
import { getGiftFinderConfig, isGiftFinderLinkVisible } from '../giftFinder/giftFinderSettings';
import { getCustomJewelryConfig, isCustomJewelryLinkVisible } from '../jewelry/customJewelrySettings';
import './shop-service-cards.css';

/**
 * Shopify-style dual promo row on /shop — Gift finder + Custom jewelry side by side.
 */
export default function ShopServiceCards() {
  const { settings } = useSiteSettings();
  const storeCopy = settings?.store_copy;
  const showGiftFinder = isGiftFinderLinkVisible(storeCopy, 'shop');
  const showCustom = isCustomJewelryLinkVisible(storeCopy, 'shop');
  const gf = getGiftFinderConfig(storeCopy);
  const cj = getCustomJewelryConfig(storeCopy);

  if (!showGiftFinder && !showCustom) return null;

  return (
    <section className="shop-service-cards" aria-label="Shop tools">
      <div className={`shop-service-cards__grid${!showGiftFinder || !showCustom ? ' shop-service-cards__grid--solo' : ''}`}>
        {showGiftFinder ? (
          <Link to="/gift-finder" className="shop-service-card shop-service-card--gift">
            <span className="shop-service-card__icon" aria-hidden="true">
              🎁
            </span>
            <span className="shop-service-card__eyebrow">{gf.eyebrow || 'Gift finder'}</span>
            <span className="shop-service-card__title">{gf.title || 'Find the perfect gift'}</span>
            <span className="shop-service-card__lead">
              {gf.subtitle || 'Answer a few questions — we shortlist pieces from the catalog.'}
            </span>
            <span className="shop-service-card__cta">
              {gf.shop_button_label || 'Open gift finder'}
            </span>
          </Link>
        ) : null}

        {showCustom ? (
          <Link to="/custom-jewelry" className="shop-service-card shop-service-card--custom">
            <span className="shop-service-card__icon" aria-hidden="true">
              ✨
            </span>
            <span className="shop-service-card__eyebrow">{cj.card_eyebrow}</span>
            <span className="shop-service-card__title">{cj.card_title}</span>
            <span className="shop-service-card__lead">{cj.card_lead}</span>
            <span className="shop-service-card__cta">
              {cj.card_cta}
            </span>
          </Link>
        ) : null}
      </div>
    </section>
  );
}
